<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" size="small" :ref="searchForm"
          style="margin-top: 20px">
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="产品名称：">
              <el-input size="medium" placeholder="请输入产品名称" minlength="2" v-model="searchForm.NAME" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="{ span: 1, offset: 1 }" :lg="1" :md="1">
            <el-button size="medium" type="primary" @click="queryData">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="openAdd(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增" :visible.sync="editFormVisible" width="30%" center>
      <el-form :ref="editForm" :model="editForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="产品别名：">
          <el-input v-model="editForm.ALIAS_NAME"></el-input>
        </el-form-item>
        <el-form-item label="生产部门：">
          <el-select filterable v-model="editForm.department" style="width: 100%">
            <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="addProduct('editForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addProductionFun, queryProductFun } from 'api/production';
import { queryDepartment } from 'api/productDepart';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      searchForm: {},
      editFormVisible: false,
      editForm: {},
      departmentList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryDepartment();
  },
  methods: {
    queryData() {
      const params = {
        PRODUCT_NAME: this.searchForm.NAME,
      };
      if (!this.searchForm.NAME) {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
        return false;
      }
      queryProductFun(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    addProduct(row) {
      const params = {
        CP_CODE: this.editForm.PRODUCT_CODE,
        ALIAS_NAME: this.editForm.ALIAS_NAME,
        DEPARTMENT_ID: this.editForm.department,
      };
      addProductionFun(params).then((result) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.editFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/addProduction.vue